import { defineMessages } from 'react-intl';

export default defineMessages({
  accessoriesShopNowButtonText: {
    id: 'app.accessories.buttons.shopNow',
    defaultMessage: 'Shop now',
  },
  accessoriesAnnouncementTitle: {
    id: 'app.accessories.announcement.title',
    defaultMessage: 'MOO Products',
  },
  accessoriesAnnouncementBody: {
    id: 'app.accessories.announcement.body',
    defaultMessage:
      'You can now order MOO products like Notebooks and Business Card Holders straight from your business account',
  },
  accessoriesAnnouncementCallout: {
    id: 'app.accessories.announcement.callout',
    defaultMessage: 'NEW',
  },
  accessoriesSaving: {
    id: 'app.accessories.detail.saving',
    defaultMessage: "You're saving",
  },
  productUnavailableOverlayText: {
    id: 'app.accessories.productUnavailable.imageOverlay.text',
    defaultMessage: 'Product not available',
  },
  quantityLabel: {
    id: 'app.accessories.quantity.label',
    defaultMessage: 'Quantity',
  },
  outOfStockMessage: {
    id: 'app.accessories.outOfStock.text',
    defaultMessage: 'Out of stock',
  },
  addToCartButtonText: {
    id: 'app.accessories.addToCart.text',
    defaultMessage: 'Add to cart',
  },
  customisablePillText: {
    id: 'app.accessories.customisable.pill.text',
    defaultMessage: 'Customizable',
  },
  customisableMessageText: {
    id: 'app.accessories.customisable.message.text',
    defaultMessage: "Want to customize this product with your company's branding?",
  },
  customisableButtonText: {
    id: 'app.accessories.customisable.button.text',
    defaultMessage: 'Get in touch',
  },
  customisableFormDialogTitle: {
    id: 'app.accessories.customisable.form.title',
    defaultMessage: 'Let us know what you are looking for',
  },
  customisableFormDialogCancelBtn: {
    id: 'app.accessories.customisable.form.cancel',
    defaultMessage: 'Cancel',
  },
  customisableFormDialogSubmitBtn: {
    id: 'app.accessories.customisable.form.submit',
    defaultMessage: 'Submit',
  },
  customisableFormDialogSuccess: {
    id: 'app.accessories.customisable.form.success',
    defaultMessage: 'Submit',
  },
  customisableFormDialogFailure: {
    id: 'app.accessories.customisable.form.failure',
    defaultMessage: 'Submit',
  },
});
